var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('AxLogin',{attrs:{"signup-route":_vm.signupRoute},on:{"auth-success":_vm.authSuccess}})
}
var staticRenderFns = []

export { render, staticRenderFns }